<mga-google-analytics></mga-google-analytics>
<!-- <app-home></app-home> -->
<ngx-spinner></ngx-spinner>
<router-outlet></router-outlet>
<script>
    (function(w,d,k,t,u,s,c,f){f=function(t){t=new Date();return t.getFullYear()+''+(t.getMonth()+1)+''+t.getDate()+'T'+t.getHours()+''+t.getMinutes()+''+t.getSeconds()};
    u='https://widgets-static.embluemail.com/accounts/3225EFB5A4EAD399/scripts/sw_322.js?ts='+f();w[k]=w[k] || [];s=d.createElement(t);
    s.async=1;s.src=u;c=d.getElementsByTagName(t)[0];c.parentNode.insertBefore(s,c);})(window,document,'_swdg','script');
    </script>